exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.box {\n  margin:0.8ex;\n  padding:0.8ex;\n  border: thin solid silver;\n}\n\ndiv.box.my {\n  border: thick double black;\n}\n\ndiv.box.isAccepted {\n  border-color: green;\n}\n\ndiv.box.isRejected {\n  border-color: red;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/rating-summary/rating-summary.component.css
// module id = ../../../../../src/app/rating-summary/rating-summary.component.css
// module chunks = main